import { usePathname } from 'next/navigation'
import React from "react";
import { Container, Row } from "react-bootstrap";
import styles from './page.module.scss'

const EnquiryForm = ({ children }) => {
	const pathName = usePathname()
	const _pathName = pathName === '/about-us' || pathName === '/recycling'
  return (
		<div className={`speak-to-us-container ${_pathName ? styles?.aboutUs : ''}`}>
			<Container>
				<Row className='speak-to-us-wapper'>{children}</Row>
			</Container>
		</div>
  )
};

export default EnquiryForm;
